import * as React from 'react';
import { Flex, Box } from 'grid-styled';
import { createFragmentContainer, graphql, RelayProp } from 'react-relay';
import EventIcon from 'material-ui/svg-icons/action/event';

/* Components */
import DropDownAutoComplete from '../AutoComplete/DropDownAutoComplete';
import ButtonLink from '../../Layouts/CeoPage/_common/ButtonLink';

/* Styles */
import './EventsDropDown.scss';
import { EventsDropDown_user } from './__generated__/EventsDropDown_user.graphql';

const blueButtonStyle = { border: '1px solid #0091EA', color: '#0091EA' };
const noop = () => {};
interface EventsDropDownProps {
  ceoId: string | null;
  firstName: string | null;
  containerWidth: number;
  handleCartHotSwap: () => void;
  handleExitEvent?: (callback?: () => void) => void;
  handleRouteChange: (path: string) => void;
  handleAuthentication: () => void;
  user: EventsDropDown_user;
  relay: RelayProp;
  handleSelectedEvent: (input: string | null) => void;
}

interface EventsDropDownState {
  eventName: string;
  showDropDown: boolean;
}

class EventsDropDown extends React.Component<
  EventsDropDownProps,
  EventsDropDownState
> {
  constructor(props: EventsDropDownProps) {
    super(props);
    this.state = {
      eventName: '',
      showDropDown: true,
    };
  }

  onSelectEvent = (eventPath: string, eventName: string) => {
    const { handleSelectedEvent } = this.props;
    this.setState({
      showDropDown: false,
      eventName,
    });
    handleSelectedEvent(eventPath);
  };

  onEditSelectedEvent = () => {
    const { handleSelectedEvent } = this.props;
    this.setState({
      showDropDown: true,
    });
    handleSelectedEvent(null);
  };

  getPrimaryLabel = (label: string) => {
    const { containerWidth } = this.props;
    if (containerWidth < 600 && label.length > 24) {
      return `${label.slice(0, 23)}...`;
    }
    return label;
  };

  render() {
    const {
      handleRouteChange,
      containerWidth,
      user,
      ceoId,
      handleCartHotSwap,
      handleExitEvent,
      handleAuthentication,
    } = this.props;
    const { showDropDown, eventName } = this.state;
    const placeHolderText = `Search my events`;
    return (
      <div>
        {showDropDown ? (
          <Flex column align="flex-start" className="EventsDropDown">
            <DropDownAutoComplete
              user={user}
              searchEvents
              searchCEOS={false}
              customCeoId={ceoId}
              showAllItemsOnFocus
              searchProducts={false}
              deactivateDropDown={noop}
              containerWidth={containerWidth}
              placeHolderText={placeHolderText}
              onSelectedEvent={this.onSelectEvent}
              handleCartHotSwap={handleCartHotSwap}
              handleExitEvent={handleExitEvent}
              handleRouteChange={handleRouteChange}
              includeShoppingWithCeoFragment={false}
              handleAuthentication={handleAuthentication}
            />{' '}
          </Flex>
        ) : (
          <Flex
            column
            justify="center"
            align="flex-start"
            className="EventsDropDownContainer"
          >
            <Flex align="center">
              <Box>
                <EventIcon color="black" />
              </Box>
              <Box className="EventsDropDownFullName">
                {this.getPrimaryLabel(eventName)}
              </Box>
              <Box>
                <ButtonLink
                  htmlLabel="Edit"
                  eventId=""
                  onClick={this.onEditSelectedEvent}
                  style={blueButtonStyle}
                />
              </Box>
            </Flex>
          </Flex>
        )}
      </div>
    );
  }
}

export default createFragmentContainer(EventsDropDown, {
  user: graphql`
    fragment EventsDropDown_user on User {
      ...DropDownAutoComplete_user
    }
  `,
});
